module.exports = __webpack_public_path__ + "9dcd85be09f67d107265077e58629892.svg";